import { ApiRequest, RequestMethod } from "../../request";

export async function removeUpgrade(
  fighterId: string,
  fighterWeaponId: string,
  upgradeId: string,
  refundMode: number
): Promise<boolean> {
    const URL = `/api/fighter/${fighterId}/fighter-weapon/remove-upgrade`;
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.DELETE);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody({
    fighterWeaponId: fighterWeaponId,
    upgradeId: upgradeId,
    refundMode: refundMode,
  });

  return (await apiRequest.send()).status === 200;
}
